module.exports = __webpack_public_path__ + "media/books/Books-Pile-Before-4ec151d7.jpg";